import { Icon } from './_Icon';
export const ListIcon = (props) => (
  <Icon {...props} d="M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01" />
);
